import { render } from "./Rack.vue?vue&type=template&id=9b97575a"
import script from "./Rack.vue?vue&type=script&lang=js"
export * from "./Rack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__